<template>
  <QBanner
    :class="['sai-banner', `bg-${backgroundColor}`, `text-${textColor}`]"
    v-on="$listeners"
    v-bind="$attrs"
    :inline-actions="inlineActions"
  >
    <template>
      <slot />
    </template>

    <template v-slot:action>
      <slot name="action">
        <QBtn
          icon="eva-close-outline"
          color="white"
          flat
          round
          size="12px"
          @click="(e) => $emit('close', e)"
        />
      </slot>
    </template>
  </QBanner>
</template>

<script>
import { QBanner, QBtn } from 'quasar';

export default {
  name: 'SAIBanner',
  props: {
    backgroundColor: {
      type: String,
      default: 'primary-gradient'
    },
    textColor: {
      type: String,
      default: 'white'
    },
    inlineActions: {
      type: Boolean,
      default: true
    }
  },
  components: { QBanner, QBtn }
};
</script>
